export default __webpack_public_path__ + "static/media/check.a6348505.png";